import { useNode } from "@craftjs/core";
import React, { useEffect, useMemo, useState } from "react";
// import "./Text.scss";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import "../../../FroalaEditor/children/FroalaTextEditor/index.scss";
import { sanitizeUserHtml } from "../../../../utils/sanitizeHtml";
import { BlockIndicator } from "../../Shared/BlockIndicator";
import { useDispatch, useSelector } from "react-redux";

import useApplyGlobalSettings, {
  CODEBLOCK_TYPES,
} from "../../../../hooks/useApplyGlobalSettings";
import TextEditorSettings from "./TextEditorSettings";

export const Text = ({
  text,
  fontSize,
  textAlign,
  padding,
  isApplyPaddingOnAllSides,
  allSidePadding,
  headingProps,
  paragraphProps,
  lineHeight,
  ...props
}) => {
  const {
    connectors: { connect, drag },
    selected,
    actions: { setProp },
  } = useNode((state) => ({
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));
  const dispatch = useDispatch();
  const { text: textProps } = useSelector((state) => state.codeblockStyles);

  const [editable, setEditable] = useState(false);

  useApplyGlobalSettings(setProp, CODEBLOCK_TYPES.Text);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setProp((props) => {
        // Don't copy text value, only styles
        props.fontSize = props.fontSize || textProps.fontSize;
        props.padding = props.padding || { ...textProps.padding };
        props.isApplyPaddingOnAllSides =
          props.isApplyPaddingOnAllSides || textProps.isApplyPaddingOnAllSides;
        props.allSidePadding = props.allSidePadding || textProps.allSidePadding;
        props.headingProps = props.headingProps || {
          ...textProps.headingProps,
        };
        props.paragraphProps = props.paragraphProps || {
          ...textProps.paragraphProps,
        };
        props.lineHeight = props.lineHeight || textProps.lineHeight;
      });
    }, 5);

    // Cleanup timeout if the component unmounts or dependencies change
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    if (selected) {
      return;
    }

    setEditable(false);
  }, [selected]);

  const paddingStyle = isApplyPaddingOnAllSides
    ? `${allSidePadding}px`
    : padding
    ? `${padding?.top}px ${padding?.right}px ${padding?.bottom}px ${padding?.left}px`
    : undefined;

  const froalaCssVariables = useMemo(() => {
    const hp = headingProps || {};
    const pp = paragraphProps || {};
    return {
      "--heading-color": hp.fontColor || "black",
      "--heading-family": hp.fontFamily || "Poppins, sans-serif",
      "--heading-size": `${hp.fontSize || 16}px`,
      "--paragraph-color": pp.fontColor || "black",
      "--paragraph-family": pp.fontFamily || "Poppins, sans-serif",
      "--paragraph-size": `${pp.fontSize || 14}px`,
      ...(lineHeight ? { "--line-height": lineHeight } : {}),
    };
  }, [headingProps, paragraphProps, lineHeight]);

  return (
    <div
      {...props}
      ref={(ref) => {
        connect(drag(ref));
      }}
      onClick={() => selected && setEditable(true)}
    >
      <BlockIndicator>
        <div
          className="froalaEditor removeOutlineOnWhiteText"
          style={{
            padding: paddingStyle,
            ...froalaCssVariables,
          }}
        >
          <FroalaEditorView
            model={sanitizeUserHtml(
              text || '<p style="color: grey;">Add Text Here</p>'
            )}
          />
        </div>
      </BlockIndicator>
    </div>
  );
};

export const TextDefaultProps = {};

Text.craft = {
  props: TextDefaultProps,
  related: {
    settings: TextEditorSettings,
  },
};
